<template>
  <div>
    <Breadcrumbs :items="itemsBreadcrumbs" class="ml-n6"/>
    <Heading :title="t$.routeTitle" :subtitle="headerSubTitle" header headerColor="gray scale200" />
    <Row>
      <Col cols="6">
        <TextField
          class="pb-4"
          :label="t$.label"
          :hint="t$.hint"
          :placeholder="t$.placeholder"
          v-model="site.domain"
          required
          type="text"
          :errorMessages="domainErrors"
        />
        <p class="text-paragraph-2 font-weight-regular mb-10" v-text="t$.explanation"/>
        <Button v-bind="buttonProps" :label="t$.button" color="primary" block @click="renameDomain"/>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col, Heading, Button, TextField, useLocale, useValidation, Breadcrumbs } from '@locaweb/design-system-vue'
import { SitesRoutesPath } from '@/views/site/router'
import { checkDomain, changeDomain } from '@/views/site/api/site.api'
import Site from '@/views/site/api/model/Site'

export default {
  name: 'SiteDomain',
  components: {
    Row,
    Col,
    Heading,
    Button,
    TextField,
    Breadcrumbs
  },
  props: {
    id: String
  },
  data () {
    return {
      site: {},
      messageErrorDomain: '',
      domainStatusCheck: false,
      loading: false
    }
  },
  methods: {
    renameDomain () {
      this.domainCheck(this.site, this.id)
    },
    async domainCheck (site, id) {
      this.loading = true
      this.messageErrorDomain = ''
      this.statusError = ''
      try {
        const data = await checkDomain(site.domain, id)
        this.domainStatusCheck = data.status
        const updateDomain = {
          plan_id: this.dataSite.plan_id,
          old_wordpress_url: this.dataSite.domain,
          new_wordpress_url: this.site.domain,
          wordpress_id: this.dataSite.wordpress_id
        }
        if (this.domainStatusCheck !== 200) {
          this.loading = false
        }
        this.domainChange(updateDomain)
      } catch ({ response: { status, data } }) {
        if (status === 422) {
          this.loading = false
          this.messageErrorDomain = data.message
          this.domainStatusCheck = status
          this.domainErrors = data.message
        } else {
          this.domainErrors = console.error('Algo deu errado. Por favor, tente novamente.')
        }
      }
    },
    domainChange (data) {
      changeDomain(data)
      setTimeout(() => {
        this.loading = false
        this.$router.push(SitesRoutesPath.LISTAR.path.replace(':id', this.dataSite.plan_id))
      }, 6000)
    }
  },
  setup () {
    const t$ = useLocale('sites.domain')
    const v$ = useValidation()
    return {
      t$,
      v$
    }
  },
  validations: Site.validations,
  computed: {
    ...Site.validationsErrors,
    statusDomainCheck () {
      let status = ''
      if (this.site.domain === '') {
        status = false
      } else {
        status = this.domainStatusCheck
      }
      return status
    },
    buttonProps () {
      let status = true
      if (this.site.domain) {
        if (this.domainErrors.length <= 0) {
          status = false
        }
      }
      const disabled = {
        true: true,
        false: false
      }
      const props = {
        disabled: disabled[status],
        loading: this.loading
      }

      return props
    },
    dataSite () {
      const sites = JSON.parse(localStorage.getItem('dataSites'))
      const data = sites.filter(item => parseInt(this.id) === item.id)
      return data[0]
    },
    headerSubTitle () {
      const subTitle = this.t$.subtitle.replaceValues(this.dataSite)
      return subTitle
    },
    itemsBreadcrumbs () {
      const title = JSON.parse(localStorage.getItem('headerProps'))
      const sites = JSON.parse(localStorage.getItem('dataSites'))
      const data = sites.filter(item => parseInt(this.id) === item.id)

      const items = [
        { text: 'Listagem de Planos', to: '/', disabled: false, exact: true },
        { text: title, to: `/${data[0].plan_id}`, disabled: false, exact: true },
        { text: 'Alterar Domínio', to: '/', disabled: true, exact: true }
      ]
      return items
    }
  }
}
</script>
